import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Login from "./Login/Login";
import ForgotPassword from "./Login/ForgotPassword";
import ResetPassword from "./Login/ResetPassword";
import PublicPageNotFound from "./PublicPageNotFound";

const UnAuthRoute: React.FC = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:userId/:code" element={<ResetPassword />} />
      <Route path="/" element={<Navigate to="/login" replace />} />
      <Route path="*" element={<PublicPageNotFound />} />
    </Routes>
  );
};
export default UnAuthRoute;
